
export default {
  name: 'ReusablePagination',

  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 3,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    topElementID: {
      type: String,
      required: false,
      default: 'nav-top',
    },
  },

  computed: {
    startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        const start = this.totalPages - (this.maxVisibleButtons - 1);

        if (start === 0) {
          return 1;
        } else {
          return start;
        }
      }

      return this.currentPage - 1;
    },
    endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages() {
      const range = [];

      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage,
        });
      }

      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
    noProduct() {
      return this.total === 0;
    },
  },

  methods: {
    onClickFirstPage() {
      // console.log('onClickFirstPage');
      this.$emit('pagechanged', {pageValue: 1, hash: this.$route.hash });
      if (this.$route.fullPath.includes('happy-kids')) {
        this.jumpToMiddle();
      } else {
        this.jumpToTop();
      }
    },
    onClickPreviousPage() {
      this.$emit('pagechanged', {pageValue: this.currentPage - 1, hash: this.$route.hash});
      if (this.$route.fullPath.includes('happy-kids')) {
        this.jumpToMiddle();
      } else {
        this.jumpToTop();
      }
    },
    onClickPage(page) {
      this.$emit('pagechanged', {pageValue: page, hash: this.$route.hash});
      if (this.$route.fullPath.includes('happy-kids')) {
        this.jumpToMiddle();
      } else {
        this.jumpToTop();
      }
    },
    onClickNextPage() {
      this.$emit('pagechanged', {pageValue: this.currentPage + 1, hash: this.$route.hash});
      if (this.$route.fullPath.includes('happy-kids')) {
        this.jumpToMiddle();
      } else {
        this.jumpToTop();
      }
    },
    onClickLastPage() {
      // console.log('onClickLastPage');
      this.$emit('pagechanged', {pageValue: this.totalPages, hash: this.$route.hash});
      if (this.$route.fullPath.includes('happy-kids')) {
        this.jumpToMiddle();
      } else {
        this.jumpToTop();
      }
    },
    isPageActive(page) {
      return this.currentPage === page;
    },
    jumpToTopElement() {
      location.href = '#';
      location.href = '#' + this.topElementID;
    },
    jumpToTop() {
      window.scrollTo(0, 0);
    },
    jumpToMiddle() {
      location.href = '#product';
    },
  },
};
